import {
  BooleanField,
  TextField,
  ImageField,
  EnumField,
} from '@sentecacommerce-theme/base'
import { Dispatch, SetStateAction } from 'react'
import { MenuItem, Labels } from '../MenuLayout/MenuLayout.props'
import { TopStripType } from './Components/TopNavStrip'

export enum BottomMenuEnum {
  empty = 'No content',
  moreProducts = 'Additional products',
  promo = 'Promotional products',
}

export type SearchBoxLabels = {
  recentSearchesLabel: TextField
  popularSearchesLabel: TextField
  suggestedBrandsLabel: TextField
  suggestedCategoriesLabel: TextField
  productsLabel: TextField
  promoOffersLabel: TextField
  blogLabel: TextField
  blog: {
    blogTitle: TextField
    image: ImageField
    description: TextField
    url: TextField
  }
}

export type SearchBox = {
  labels: SearchBoxLabels
  labelsColor: TextField
  textColor: TextField
  priceColor: TextField
  backgroundColor: TextField
  bottomMenu: EnumField<BottomMenuEnum>
  withRecent: BooleanField
  withSuggested: BooleanField
}

export type NavbarProps = {
  menuItems: MenuItem[]
  drawerOpen: BooleanField
  handleOpen: Dispatch<SetStateAction<boolean>>
  drawerToggleHandler: () => void
  isIndex?: boolean // this is not coming from the cms.
  suggestedMenus: SuggestedMenu[]
  mainRef: React.RefObject<any>
  labels: Labels
  searchBox: SearchBox
  topStrip: TopStripType[]
}

export type SuggestedMenu = {
  menuName: TextField
  items: {
    label: TextField
    url: TextField
  }[]
}
